import { Link } from 'react-router-dom'
import styles from './InvoiceManager.module.css'
import { useNavigate, useLocation } from 'react-router-dom'


const InvoiceManager = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const exhibitorAccount = location.state    
    // functions
    const launchMailto = () => {
        window.location = 'mailto:' + exhibitorAccount.email
    }
    return (
        <div id={styles.eventConfigurePage}>
            <h1>Exhibitor Management</h1><br />
            <h2>Control exhibitor setup for {exhibitorAccount.firstName} {exhibitorAccount.lastName} - {exhibitorAccount.organization} ({exhibitorAccount.refNumber}).</h2><br />
            <div id={styles.eventConfigureContainer}>
                <Link to={`/GenerateInvoice`} className={styles.eventLinks}
                    state={exhibitorAccount}
                    title="Print or generate pdf of invoice.">
                    <h3>View Invoice</h3>
                </Link>
                <Link 
                    onClick={launchMailto}
                    className={styles.eventLinks}
                    state={exhibitorAccount}
                    title="Send email to exhibitor.">
                    <h3>Contact {exhibitorAccount.firstName} {exhibitorAccount.lastName}</h3>
                </Link>
            </div>

            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default InvoiceManager;